import React from "react";
import Banner from "../Components/Banner";
import About from "../Components/About";
import Skills from "../Components/Skills";
import Projects from "../Components/Projects";
import Services from "../Components/Services";
import FooterAbout from "../Components/FooterAbout";
import GetInTouch from "../Components/GetInTouch";
import Header from "../../Shared/Header";
import Footer from "../../Shared/Footer";

export default function Home() {
  return (
    <div className="">
      <Header />
      <Banner />
      <hr className="border-[#28282b]" />
      <About />
      {/* <hr className="border-[#28282b]" /> */}
      <Skills />
      {/* <hr className="border-[#28282b]" /> */}
      <hr className="border-[#28282b]" />
      <Projects />
      <hr className="border-[#28282b]" />
      <Services />
      <hr className="border-[#28282b]" />
      <FooterAbout />
      <hr className="border-[#28282b]" />
      <GetInTouch />
      <hr className="border-[#28282b]" />
      {/* {projectCategory != "uiux" && <Footer />} */}
      <Footer />
    </div>
  );
}
